/* eslint-disable global-require */
/* eslint-disable no-bitwise */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import toast from 'react-hot-toast';

import { Buffer as BufferLib } from 'buffer';

import * as constants from './constants';

export { default as useScroll } from './useScroll';

export { default as useFeatureFlags } from './useFeatureFlags';

export { default as cryptography } from './cryptography';

export { useDebounce } from './useDebounce';

export const { defaultSchedulers, UTCValues, defaultDeploymentStatus } =
  constants;

export function extractKeys(arr) {
  return arr.flatMap((i) => Object.keys(i));
}

export function arrUniq(arr) {
  return [...new Set(arr)];
}

export const mapTableColumns = (item) => ({
  Header: item,
  accessor: item
});

export const removeFromArray =
  (...args) =>
  (item) => {
    if (typeof item !== 'object') {
      return !args.includes(item);
    }
    let keys = Object.keys(item).filter((key) => !args.includes(key));
    return keys.reduce(
      (acc, key) => ({
        ...acc,
        [key]: item[key]
      }),
      {}
    );
  };

export const isEmpty = (obj) => {
  for (let i in obj) return false;
  return true;
};

export function generateId() {
  const alphabet = 'zyxwvutsrqponmlkjihgfedcba9876543210';
  let id = '';
  let len = 8;
  while (len--) id += alphabet[(Math.random() * 36) | 0];
  return id;
}

export function uuid() {
  const { v4: uuidv4 } = require('uuid');
  return uuidv4();
}

export const convertJsonToStr = (data) => {
  try {
    let formattedResult = data;
    if (typeof data === 'string') {
      formattedResult = JSON.parse(data);
    }
    return JSON.stringify(formattedResult, null, 4);
  } catch (error) {
    console.log(error);
    return data;
  }
};

export function notify({
  message,
  type = 'success',
  duration = 5000,
  style = {},
  ...config
}) {
  return toast?.[type](message, {
    position: 'bottom-center',
    duration: type === 'loading' ? Infinity : duration,
    style: {
      height: '75px',
      width: '100%',
      marginLeft: '100px',
      fontWeight: 'bolder',
      backgroundColor: type === 'error' ? '#F43939' : '#FFF',
      color: type === 'error' ? '#FFF' : 'inherit',
      ...style
    },
    ...config
  });
}

export function notifyException(err) {
  console.log({ err });
  console.log(err?.response?.data?.reason);

  if (!err.response) {
    notify({
      message:
        err.message === 'Network Error'
          ? 'Network Error. Check your internet connection and try again later.'
          : err.message,
      type: 'error'
    });

    return;
  }

  const {
    response: { status, data }
  } = err;

  // TODO: refactor this...
  if (status === 409 || (status === 500 && data?.reason)) {
    const { message, reason } = data;
    console.log({ reason });
    notify({
      message:
        reason === ('already_registred_user' || 'entryAlreadyExists')
          ? 'The email is already registered'
          : reason === 'not_invited'
          ? 'The user was not invited yet'
          : message,
      type: 'error'
    });

    return;
  }

  const { errors } = data;

  if (status < 500 && errors) {
    Object?.keys?.(errors).map((el) => {
      console.log('errors[el]', errors[el]);
      return notify({
        message: `${el} ${errors?.[el]?.[0]}.`,
        type: 'error'
      });
    });

    return;
  }

  notify({
    message: 'Something went wrong. Try again later.',
    type: 'error'
  });
}

const minutes = (min) => {
  return min <= 9 ? `0${min}` : min;
};

export const formattedDate = (data) => {
  const date = new Date(data);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
  return `${days[date.getDay()]}, ${
    months[date.getMonth()]
  } ${date.getDate()}, ${date.getHours()}h${minutes(date.getMinutes())}`;
};

export const convertToISOString = (date) => {
  return date.toISOString();
};

export const getRangeValues = (range) => {
  switch (range) {
    case 'Last 5 minutes':
      return {
        from: convertToISOString(
          new Date(new Date().setMinutes(new Date().getMinutes() - 5))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 30 minutes':
      return {
        from: convertToISOString(
          new Date(new Date().setMinutes(new Date().getMinutes() - 30))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 1 hour':
      return {
        from: convertToISOString(
          new Date(new Date().setHours(new Date().getHours() - 1))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 3 hours':
      return {
        from: convertToISOString(
          new Date(new Date().setHours(new Date().getHours() - 3))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 6 hours':
      return {
        from: convertToISOString(
          new Date(new Date().setHours(new Date().getHours() - 6))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 24 hours':
      return {
        from: convertToISOString(
          new Date(new Date().setHours(new Date().getHours() - 24))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 2 days':
      return {
        from: convertToISOString(
          new Date(new Date().setDate(new Date().getDate() - 2))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 7 days':
      return {
        from: convertToISOString(
          new Date(new Date().setDate(new Date().getDate() - 7))
        ),
        to: convertToISOString(new Date())
      };
    case 'Last 15 days':
      return {
        from: convertToISOString(
          new Date(new Date().setDate(new Date().getDate() - 15))
        ),
        to: convertToISOString(new Date())
      };
    default:
      return {
        from: convertToISOString(
          new Date(new Date().setDate(new Date().getDate() - 0))
        ),
        to: convertToISOString(new Date())
      };
  }
};

export function convertBase64ToJson(payload) {
  const isB64 =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

  return isB64.test(payload)
    ? JSON.parse(
        BufferLib.from(payload, 'base64').toString().replace(/\n/g, '\\n')
      )
    : payload;
}

export function formatBytes(bytes) {
  if (typeof bytes !== 'number') {
    throw new TypeError('Argument must be a number');
  }

  const prefixes = ['B', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;
  let num = bytes;

  while (num >= 1024 && index < prefixes.length - 1) {
    num /= 1024;
    index++;
  }

  // Round to 2 decimal places
  const roundedNum = Math.round(num * 100) / 100;

  return `${roundedNum} ${prefixes[index]}`;
}

export function formatDate(value) {
  const date = new Date(+value);
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  return date.toLocaleDateString('en-US', options);
}

export function convertLastExecutionWithTimezone(resource) {
  const receivedTime = resource?.lastExecution?.finishedAt;
  let utcDate = new Date(receivedTime);
  utcDate.setHours(
    utcDate.getHours() + Number(resource?.lastExecution?.ingestion_utc || 0)
  );
  const localTime = convertToISOString(utcDate);
  return `${resource?.lastExecution?.status} at ${localTime}`;
}
